<template>
  <div class="smartPark">
    <coning />
  </div>
</template>

<script>
import coning from "../components/coning";
export default {
  components: {
    coning
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/smartPark.vue